import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextBarComponent } from './context-bar.component';
import {EventModule} from '../event/event.module';
import {TaskModule} from '../task/task.module';
import ContextBarService from './context-bar.service';
import {MatRippleModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {DoingModule} from '../doing/doing.module';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {NoteModule} from '../note/note.module';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatMenuModule} from "@angular/material/menu";
import {MiniCalendarModule} from "../mini-calendar/mini-calendar.module";
import { EventsComponent } from './events/events.component';
import { DoingsComponent } from './doings/doings.component';
import { TasksComponent } from './tasks/tasks.component';
import { NotesComponent } from './notes/notes.component';
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatButtonModule} from "@angular/material/button";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {WidgetBoxModule} from "../widget-box/widget-box.module";
import {MatInputModule} from "@angular/material/input";



@NgModule({
  declarations: [ContextBarComponent, EventsComponent, DoingsComponent, TasksComponent, NotesComponent],
    exports: [
        ContextBarComponent,
        EventsComponent,
        DoingsComponent,
        NotesComponent,
        TasksComponent
    ],
    imports: [
        CommonModule,
        EventModule,
        TaskModule,
        NoteModule,
        MatRippleModule,
        MatDialogModule,
        DoingModule,
        RouterModule,
        FormsModule,
        InfiniteScrollModule,
        MatCheckboxModule,
        MatMenuModule,
        MiniCalendarModule,
        MatButtonToggleModule,
        MatButtonModule,
        MatProgressBarModule,
        WidgetBoxModule,
        MatInputModule
    ],
  providers: [
    ContextBarService
  ]
})
export class ContextBarModule { }
